import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Game from "./components/Game";
import "./App.css";

const AppContent: React.FC = () => {
  const location = useLocation();
  const showNav = location.pathname === "/";

  useEffect(() => {
    if (showNav) {
      localStorage.removeItem("gameState_regular");
      localStorage.removeItem("gameState_pub");
      localStorage.removeItem("gameState_sfw");
      localStorage.removeItem("gameState_nsfw");
    }
  }, [showNav]);

  useEffect(() => {
    let title = "DrinkUp - The Card Game";
    if (location.pathname === "/pub") title = "DrinkUp - Pub Mode";
    else if (location.pathname === "/sfw") title = "DrinkUp - SFW Mode";
    else if (location.pathname === "/nsfw") title = "DrinkUp - X-Rated Mode";
    else if (location.pathname === "/regular") title = "DrinkUp - All Mode";
    document.title = title;
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-transparent flex flex-col items-center p-6">
      {showNav && (
        <>
          <h1 className="text-3xl font-bold mb-6 text-white">
            DrinkUp Card Game
          </h1>
          <nav className="mb-6 grid grid-cols-2 gap-4">
            <Link
              to="/regular"
              className="bg-[#0a0a2a] border-2 border-[#3a3a7a] text-white font-bold py-3 px-6 rounded-2xl shadow-lg transition-all duration-200 text-lg hover:bg-[#18184a] hover:border-[#5a5ab0] focus:outline-none focus:ring-2 focus:ring-[#5a5ab0] text-center"
            >
              NORMAL 👀🌶️
            </Link>
            <Link
              to="/pub"
              className="bg-[#0a0a2a] border-2 border-[#3a3a7a] text-white font-bold py-3 px-6 rounded-2xl shadow-lg transition-all duration-200 text-lg hover:bg-[#18184a] hover:border-[#5a5ab0] focus:outline-none focus:ring-2 focus:ring-[#5a5ab0] text-center"
            >
              PUB 🍻🍸
            </Link>
            <Link
              to="/clothes"
              className="bg-[#0a0a2a] border-2 border-[#3a3a7a] text-white font-bold py-3 px-6 rounded-2xl shadow-lg transition-all duration-200 text-lg hover:bg-[#18184a] hover:border-[#5a5ab0] focus:outline-none focus:ring-2 focus:ring-[#5a5ab0] text-center"
            >
              CLOTHES 🩲👙
            </Link>
            <Link
              to="/nsfw"
              className="bg-[#0a0a2a] border-2 border-[#3a3a7a] text-white font-bold py-3 px-6 rounded-2xl shadow-lg transition-all duration-200 text-lg hover:bg-[#18184a] hover:border-[#5a5ab0] focus:outline-none focus:ring-2 focus:ring-[#5a5ab0] text-center opacity-50 cursor-not-allowed pointer-events-none"
            >
              NSFW 🥵💋
            </Link>
          </nav>
        </>
      )}
      <Routes>
        <Route path="/regular" element={<Game mode="regular" />} />
        <Route path="/pub" element={<Game mode="pub" />} />
        <Route path="/clothes" element={<Game mode="clothes" />} />
        <Route path="/nsfw" element={<Game mode="nsfw" />} />
        <Route
          path="*"
          element={
            <div className="text-white">Select a mode to start playing!</div>
          }
        />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <div
      style={{
        // backgroundImage: "url('/images/background.jpg')",
        // backgroundSize: "cover",
        // backgroundRepeat: "repeat",
        background: "#111727",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
